import angular from "angular"
import "../r2-translate/translate"
import "../about/about"
import "../current-user/current-user"
import "../notification/notification"

export default angular.module("headerModule", ["r2TranslateModule", "aboutModule", "currentUserModule", "notificationModule"])
